/** Enum defining authentication URLs for Salesforce production and sandbox environments */
enum OAUTH {
  /**
   * Production and Dev environment
   */
  AUTH_URL = 'https://login.salesforce.com/services/oauth2/authorize',
  /**
   * Sandbox environment
   */
  SANDBOX_AUTH_URL = 'https://test.salesforce.com/services/oauth2/authorize',
}

export { OAUTH };
